export default "__VITE_ASSET__DFot4FB0__"